import { Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { FactoryService } from '@services/common/factory.service';
@Component({
  standalone: false,
  selector: 'com-toast',
  templateUrl: './com-toast.component.html',
  styleUrls: ['./com-toast.component.scss']
})
export class ComToastComponent implements OnChanges {
  @ViewChild('icon') icon: ElementRef;
  @Input() showToast: boolean = false;
  @Input() text: string;
  @Input() successFlag: boolean = true; //control show radio-right / warning icon
  @Input() marginBtm: string;
  @Input() type: string; // 'success' | 'fail' | 'warning'

  constructor(
    public factorySer: FactoryService
  ) { }

  ngOnChanges(): void {
    const icon = this.icon?.nativeElement as HTMLElement;
    if (icon) {
      if(this.showToast){
        this.type = this.type || (this.successFlag ? 'success' : 'fail');
        icon.className = 'toast-icon ' + this.type;
      } else {
        icon.className = 'toast-icon '
      }
    }
  }
}